<div class="overlay" [ngClass]="{'show': loading}">

</div>
<div class="spanner" [ngClass]="{'show': loading}">
  <div class="spin-wrap">
    <div class="spin-wrap-content">
      <div class="spinner-container">
        <div class="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-lg-12" *ngIf="examData.showQuestionList">
  <div class="card">
    <div class="card-header bg-transparent" style="text-align: center;">
      <h2 class="mb-0 que-list">{{language.questionList}}</h2>
      <div class="ques_status">
        <div class="col-sm-8 col-sm-4 mx-auto center-status">
          <div class="row">
            <div class="col-sm-6 ques_status_item">
              <h4><span class="mx-2">{{language.answeredQuestions}}</span></h4>
              <button class="badge-answered"></button>
            </div>
            <div class="col-sm-6 ques_status_item">
              <h4><span class="mx-2">{{language.unansweredQuestions}}</span></h4>
              <button class=" badge-unanswered">
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="qlistfont"><span><a href="javascript:void(0)" (click)="goBack()" class="return-link"><strong>&lt;&lt;
              {{language.goBack}} </strong></a></span></div>
    </div>
    <div class=" card-body">
      <div class="col-sm-12" *ngFor="let group  of groupedQuestionsArray">
        <div class="each-que">
          <h5 class="text-muted" *ngIf="group.category && group.category!=''">{{language.category}}: {{group.category}}
          </h5>
          <div class="row mb-1" *ngFor="let question of group.questionList">
            <div class="col-sm-12 col-md-12 col-lg-2 mx-0 h3 que-box "
              [ngClass]="{'badge-answered': question.examQuestion.answered,'badge-unanswered': !question.examQuestion.answered }">
              <a class="colorblack box-link" (click)="gotoquestion(scheduleid,question.examQuestion.questionno)">
                <button class="qdivs" style="text-align: center; border-radius: 0% !important;"
                  [ngClass]="{'badge-answered': question.examQuestion.answered,'badge-unanswered': !question.examQuestion.answered }">
                  <i class="ni"
                    [ngClass]="{'ni-tag': question.examQuestion.answered,'ni-bell-55': !question.examQuestion.answered }"></i>
                  {{language.question}} <br /> {{question.examQuestion.questionno}}
                </button></a>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-10 m-0 pt-2 h2 qlistfont question-content"
              style="max-width: 100% !important;">
              <a class="colorblack" (click)="gotoquestion(scheduleid,question.examQuestion.questionno)">
                <div *ngIf="this.examData && this.examData.showQuestionList" class="qdivs"
                  [innerHTML]="question.examQuestion.questionhtml"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>